import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../../api';
import { SearchToneRequest } from './searchtonerequest';

export class SearchToneAPI extends APIImpl<SearchToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/search-tone
        let request = "search-tone"+"?"+"language="+ this.getRequest().getSearchToneRequest().getLanguage();

        if(this.getRequest().getSearchToneRequest().getSearchKey() !==  undefined &&
        this.getRequest().getSearchToneRequest().getSearchKey() !== "")
        {
            request = request + "&" + "searchKey="+ this.getRequest().getSearchToneRequest().getSearchKey();
        }

        if(this.getRequest().getSearchToneRequest().getToneId() !== undefined && 
                this.getRequest().getSearchToneRequest().getToneId() !== "")
        {
            request = request + "&" + "toneId="+ this.getRequest().getSearchToneRequest().getToneId();
        }

        if(this.getRequest().getSearchToneRequest().getArtistKey() !== undefined && 
                this.getRequest().getSearchToneRequest().getArtistKey() !== "")
        {
            request = request + "&" + "artistKey="+ this.getRequest().getSearchToneRequest().getArtistKey();
        }

        if(this.getRequest().getSearchToneRequest().getCategoryId() !== undefined && 
        this.getRequest().getSearchToneRequest().getCategoryId() > 0)
        {
            request = request + "&" + "categoryId="+ this.getRequest().getSearchToneRequest().getCategoryId();
        }

        if(this.getRequest().getSearchToneRequest().getSortBy() !== undefined && 
        this.getRequest().getSearchToneRequest().getSortBy() !== "")
        {
            request = request + "&" + "sortBy="+ this.getRequest().getSearchToneRequest().getSortBy();
        }

        if(this.getRequest().getSearchToneRequest().getAlignBy() !== undefined && 
        this.getRequest().getSearchToneRequest().getAlignBy() !== "")
        {
            request = request + "&" + "alignBy="+ this.getRequest().getSearchToneRequest().getAlignBy();
        }

        if(this.getRequest().getSearchToneRequest().getPageNo() !== undefined && 
        this.getRequest().getSearchToneRequest().getPageNo() >= 0)
        {
            request = request + "&" + "pageNo="+ this.getRequest().getSearchToneRequest().getPageNo();
        }

        if(this.getRequest().getSearchToneRequest().getSearchLanguage() !== undefined && 
        this.getRequest().getSearchToneRequest().getSearchLanguage() !== "")
        {
            request = request + "&" + "searchLanguage="+ this.getRequest().getSearchToneRequest().getSearchLanguage();
        }

        if(this.getRequest().getSearchToneRequest().getPagePerCount() !== undefined && 
        this.getRequest().getSearchToneRequest().getPagePerCount() >= 0)
        {
            request = request + "&" + "perPageCount="+ this.getRequest().getSearchToneRequest().getPagePerCount();
        }

        return request;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneapi.tsx